import OrderingDetailsSFC from "./OrderingDetails.vue";
export const OrderingDetails = OrderingDetailsSFC;
